// Base conversion values for supported units
const UNIT_TO_CM = {
    cm: 1,
    mm: 10,
    in: 1 / 2.54
};
class Unit {
    constructor(value, unit) {
        this.valueInCm = Unit.getBaseValue(value, unit);
        this.unit = unit;
    }
    static getBaseValue(value, unit) {
        return value / UNIT_TO_CM[unit];
    }
    to(unit) {
        return create(this.valueInCm * UNIT_TO_CM[unit], unit);
    }
    toNumber(unit) {
        return this.valueInCm * UNIT_TO_CM[unit || this.unit];
    }
}
const create = (value, unit) => {
    switch (unit) {
        case "cm":
        case "mm":
        case "in":
            return new Unit(value, unit);
        default:
            throw new Error(`Unsupported Unit Type: ${unit}`);
    }
};
export default { Unit: create };
//# sourceMappingURL=Unit.js.map